import { useStyles } from './styles'
import { Grid, ButtonGroup, Popover, Paper, ClickAwayListener, MenuList, MenuItem, Typography, Tooltip } from '@material-ui/core'
import { useState, useRef } from 'react'
import { CustomButton } from '../../../CustomButton'

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

const AcaoSimples = (props) => {
  const classes = useStyles()
  const { nome, Icon, onClick, disabled, helpText } = props
  return (
    <Tooltip arrow title={(disabled && helpText) ? <Typography variant='caption'>{helpText}</Typography> : ''} placement='top-start'>
      <div className={classes.tooltipWrapper}>
        <CustomButton variant='outlined' fullWidth startIcon={<Icon />} disabled={disabled} onClick={() => onClick()} className={`${classes.tituloAcao} ${disabled ? classes.disabled : ''}`}>{nome}</CustomButton>
      </div>
    </Tooltip>
  )
}

const AcaoComposta = (props) => {
  const { options } = props
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const classes = useStyles()
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleClick = () => {
    options[selectedIndex].onClick()
  }

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const SelectedIcon = options[selectedIndex].Icon
  const allDisabled = options.every(option => option.disabled)
  return (
      <>
        <ButtonGroup fullWidth variant="outlined" ref={anchorRef} aria-label="split button">
          <CustomButton  className={`${classes.tituloAcao} ${options[selectedIndex].disabled ? classes.disabled : ''}`} style={{ flexBasis: '90%',  pointerEvents: 'auto' }} startIcon={<SelectedIcon />} onClick={handleClick} disabled={options[selectedIndex].disabled} >
            <Tooltip arrow title={(options[selectedIndex].disabled && options[selectedIndex].helpText) ? <Typography variant='caption'>{options[selectedIndex].helpText}</Typography> : ''} placement='top-start'><span>{options[selectedIndex].nome}</span></Tooltip>
          </CustomButton>
          <CustomButton  
            size="small"
            className={classes.tituloAcaoCenter} 
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="selecionar ação"
            aria-haspopup="menu"
            disabled={allDisabled}
            onClick={handleToggle}
            style={{ flexBasis: '10%' }}
          >
            <ArrowDropDownIcon />
          </CustomButton>
        </ButtonGroup>
        <Popover
          open={open}
          anchorEl={anchorRef.current}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id="split-button-menu">
                {options.map((option, index) => (
                  <MenuItem
                    key={option.nome}
                    disabled={option.disabled}
                    selected={index === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, index)}
                  >
                    {option.nome}
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Popover>
      </>
  );
}

export const PainelAcoesCesta = (props) => {
  const classes = useStyles()
  const {acoes} = props

  // const contarAcoesHabilitadas = (secao) => {
  //   let total = 0
  //   let habilitadas = 0
  //   for (const acao of secao.acoes) {
  //     if (acao.tipo === 'split') {
  //       for (const subAcao of acao.acoes) {
  //         total++
  //         habilitadas += !subAcao.disabled
  //       }
  //     } else {
  //       total++
  //       habilitadas += !acao.disabled
  //     }
  //   }
  //   return { total, habilitadas }
  // }

  return (
    <>
      <Grid item xs={12} className={classes.gridTituloAcoes}>
        <Typography className={classes.tituloAcoes}>Ações em Lote</Typography>
        <Tooltip arrow title={<Typography variant='body2'>Em caso de indisponibilidade de alguma ação, verifique a homogeneidade dos itens na cesta e as condições para execução da ação desejada.</Typography>}>
          <HelpOutlineIcon style={{fontSize:"20px"}}  />
        </Tooltip>
      </Grid>
      {acoes.map((secao) => {
        return (
          <Grid item container className={classes.secaoAcoes} key={secao.tituloSecao} spacing={1}>
            <Grid item xs={12}>
              <Typography variant='subtitle2' className={classes.tituloSecao}>{secao.tituloSecao}</Typography>
            </Grid>
            {secao.acoes.map((item, index) => {
              if (item.tipo === 'split') {
                return (
                <Grid item xs={6} className={classes.menuItem}>
                  <AcaoComposta options={item.acoes}></AcaoComposta>
                </Grid>)
              } else {
                return item.hidden ? null : (
                <Grid item xs={6} className={classes.menuItem}>
                  <AcaoSimples key={index} {...item} />
                </Grid>)
              }
            })}
        </Grid>
      )})}
  </>
  )
}